import React, { useMemo } from 'react';
import { Authenticatable } from 'components/elements';
import { useJoinGroupMutation, useGetMyAccountQuery, useLeaveGroupMutation } from 'graphql/types';
import { useHistory } from 'react-router-dom';
import { HeroActionButton } from './index.styled';

interface JoinGroupButtonProps {
  groupId: string;
}

export default function JoinGroupButton({ groupId }: JoinGroupButtonProps) {
  const history = useHistory();
  const [joinGroup, { loading: joinLoading }] = useJoinGroupMutation();
  const [leaveGroup, { loading: leaveLoading }] = useLeaveGroupMutation();
  const { data: accountResult } = useGetMyAccountQuery();

  const isJoined = useMemo(() => {
    return (accountResult?.myAccount?.data?.attributes?.groups?.data || []).some((group) => group.id === groupId);
  }, [accountResult, groupId]);

  const text = isJoined ? 'Leave Group' : 'Join Group ';
  const action = () => {
    if (isJoined) {
      leaveGroup({ variables: { groupId } });
    } else {
      joinGroup({ variables: { groupId } });
    }
  };

  return (
    <Authenticatable
      title="For joining groups you need to login first!"
      okText="Login"
      onConfirm={() => history.push('/login')}
    >
      <HeroActionButton onClick={action} loading={joinLoading || leaveLoading}>
        {text}
      </HeroActionButton>
    </Authenticatable>
  );
}
